import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "province-limit" }


const __default__ = {
  name: 'ProvinceLimit'
};

import { ShowSearchType } from 'ant-design-vue/lib/cascader';

interface IProps {
  areaList: string[];
  areaOptions: any[];
  onChange: (value: string[]) => void;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    areaList: null,
    areaOptions: null,
    onChange: null
  },
  setup(__props: any) {

const props = __props as { areaList: string[], areaOptions: any[], onChange: (value: string[]) => void }



const filter: ShowSearchType['filter'] = (inputValue, path) => {
  return path.some((option) => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
};

const getPopupContainer = () => document.getElementById('province-limit');

return (_ctx: any,_cache: any) => {
  const _component_a_cascader = _resolveComponent("a-cascader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_cascader, {
      class: "oio-select oio-cascader",
      value: __props.areaList,
      style: {"width":"100%"},
      "field-names": { label: 'name', value: 'code' },
      "max-tag-count": "responsive",
      options: __props.areaOptions,
      "show-search": { filter: filter },
      placeholder: "请选择地区",
      onChange: __props.onChange,
      getPopupContainer: getPopupContainer
    }, null, 8, ["value", "options", "show-search", "onChange"])
  ]))
}
}

})